// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + "79a8eefbc01211891cba" + ".css";
};